import axios from 'axios';
import { TOKEN_SOURCE_F3D6, TOKEN_VALID_LENGTH, TOKEN_VALID_LENGTH_F3D6 } from '../constants';
const API_TIMEOUT = 30000;
class ApiClient {
    constructor() {
        this.client = axios.create({
            timeout: API_TIMEOUT,
            headers: {
                'Content-Type': 'application/json',
            },
        });
        this.client.interceptors.request.use((config) => this.addTokenToRequest(config), (error) => {
            throw error;
        });
        this.client.interceptors.response.use((response) => response, (error) => this.handleError(error));
    }
    getBaseUrl() {
        if (process.env.NODE_ENV === 'development') {
            return window.avAppConfig.serviceUrl || '';
        }
        return '';
    }
    getToken() {
        const urlParams = new URLSearchParams(window.location.search);
        const token = urlParams.get('token') || '';
        return token;
    }
    getTokenSource() {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.get('tokenSource');
    }
    validateToken(token, tokenSource) {
        if (!token || typeof token !== 'string') {
            throw new Error('TOKEN_MISSING');
        }
        const tokenValidLength = tokenSource === TOKEN_SOURCE_F3D6 ? TOKEN_VALID_LENGTH_F3D6 : TOKEN_VALID_LENGTH;
        const isTokenValid = token.length === tokenValidLength;
        if (!isTokenValid) {
            throw new Error('TOKEN_INVALID_LENGTH');
        }
        const isValidFormat = /^[a-zA-Z0-9-_]+$/.test(token);
        if (!isValidFormat) {
            throw new Error('TOKEN_INVALID_FORMAT');
        }
    }
    addTokenToRequest(config) {
        const token = this.getToken();
        const tokenSource = this.getTokenSource();
        if (token && config.url) {
            try {
                this.validateToken(token, tokenSource);
                const baseUrl = this.getBaseUrl();
                const endpoint = config.url;
                config.url = baseUrl + endpoint + token;
            }
            catch (error) {
                console.error('Token validation failed:', error);
                throw error;
            }
        }
        return config;
    }
    handleError(error) {
        const apiError = {
            message: 'An error occurred',
            code: 'UNKNOWN_ERROR',
            statusCode: 500,
        };
        if (error.response) {
            apiError.statusCode = error.response.status;
            const responseData = error.response.data;
            apiError.message = responseData && responseData.message ? responseData.message : error.message;
            switch (error.response.status) {
                case 401:
                    apiError.code = 'TOKEN_EXPIRED';
                    apiError.message = 'Your session has expired';
                    break;
                case 403:
                    apiError.code = 'FORBIDDEN';
                    apiError.message = 'Access denied';
                    break;
                case 404:
                    apiError.code = 'NOT_FOUND';
                    apiError.message = 'Resource not found';
                    break;
                case 422:
                    apiError.code = 'VALIDATION_ERROR';
                    apiError.message = 'Invalid data provided';
                    break;
                case 500:
                    apiError.code = 'SERVER_ERROR';
                    apiError.message = 'Server error occurred';
                    break;
                default:
                    apiError.code = `HTTP_${error.response.status}`;
            }
        }
        else if (error.request) {
            apiError.code = 'NETWORK_ERROR';
            apiError.message = 'Network error - please check your connection';
        }
        else {
            apiError.code = 'REQUEST_ERROR';
            apiError.message = error.message;
        }
        return Promise.reject(apiError);
    }
    async get(url, config) {
        const response = await this.client.get(url, config);
        return response.data;
    }
    async post(url, data, config) {
        const response = await this.client.post(url, data, config);
        return response.data;
    }
    async put(url, data, config) {
        const response = await this.client.put(url, data, config);
        return response.data;
    }
    async delete(url, config) {
        const response = await this.client.delete(url, config);
        return response.data;
    }
}
export const apiClient = new ApiClient();
//# sourceMappingURL=apiClient.js.map